module.exports = __webpack_public_path__ + "static/media/getto.9002d169.jpg";